
























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
//@ts-ignore
import store from "../../../../store";
import {ChatMessages} from "../../../../../types/chat-messages";
import {Player} from "../../../../../types";

@Component({
    components: {},
})

export default class PlayerCommonMessage extends Vue {
    @Prop({required: true}) private readonly message!: ChatMessages.Message;

    /**
     * Все игроки
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    private get isGuest(): boolean
    {
        const state = store.getters.getGameState;
        const player = state.playersData[this.message.playerId];
        if (typeof player === 'undefined') {
            return true;
        }
        return player.connectionStatus === 'guest';
    }

    /**
     * Массив игроков
     * @private
     */
    private get playerName(): string
    {
        const state = store.getters.getGameState;
        const player = state.playersData[this.message.playerId];
        if (typeof player === 'undefined') {
            return '';
        }
        if (player.connectionStatus === 'guest') {
            return player.name.toString().charAt(0) + player.name.toString().charAt(player.name.length - 1);
        }
        return player.name.toString();
    }

    /**
     * Цвет игрока
     * @private
     */
    private get playerColor(): string
    {
        const filteredPlayer = this.players.filter((player: Player) => {
            return player.id === this.message.playerId;
        });

        if (typeof filteredPlayer[0] !== 'undefined') {
            return filteredPlayer[0].color.code;
        }
        return '';
    }
}
